"use strict";
// AUTO-GENERATED - DO NOT EDIT
// Generated from: src/schemas/customer/wallet.schemas.ts
// Convention: See SCHEMA_NAMING_CONVENTION.md
Object.defineProperty(exports, "__esModule", { value: true });
